export default __webpack_public_path__ + "static/fitness-interno-3879b6d76a7eea1c0cf010a45da4dbb9.jpg";